import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';

Swiper.use([Autoplay, Navigation, Pagination]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initSearch();
            this.initSocial();
            this.initBanners();
            this.initPropertySlider();
        }
    }

    initSearch() {
        const tabs = document.querySelectorAll('#search .tabs li');
        const tabContents = document.querySelectorAll('#search .tab-content');

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', e => {
                tabs.forEach(tempTab => {
                    tempTab.classList.remove('active');
                });

                tabContents.forEach(tempTabContent => {
                    tempTabContent.classList.remove('active');
                });

                tab.classList.add('active');

                tabContents[i].classList.add('active')
            });
        });
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 5,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }

    initBanners() {
        new Swiper('#banners .swiper-container', {
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    initPropertySlider() {
        new Swiper('#propertySlider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                }
            }
        });
    }
}
